import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { IonMenu, Platform, ViewDidEnter } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { SharedService } from '../../../services/shared-service/shared.service';

@Component({
	selector: 'app-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrls: ['./side-nav.component.scss']
})
export class SideNaveComponent implements OnInit, ViewDidEnter {
	@Input() isAuthenticated: boolean;
	@Output() isToggle = new EventEmitter();
	// @ViewChild('menu', { static: true }) menu: IonMenu;
	@ViewChild(IonMenu) menu: IonMenu;
	isSidebarCollapsed = false;
	isShowSideMenu: boolean = false;
	items: any[] = [];
	toggle: boolean = false;
	menuItems = [
		{
			title: 'Areas',
			url: '/areas',
			icon: 'assets/svgs/areas/building-fill.svg',
			enabled: false
		},
		{
			title: 'Divisions',
			url: '/divisions',
			icon: 'assets/svgs/header/division.svg',
			enabled: false
		},
		{
			title: 'Lineitems',
			url: '/lineitems',
			icon: 'assets/svgs/header/lines.svg',
			enabled: false
		},
		{
			title: 'Trades',
			url: '/trades',
			icon: 'assets/svgs/header/trades.svg',
			enabled: false
		},
		{
			title: 'Keywords',
			url: '/keywords',
			icon: 'assets/svgs/header/keywords.svg',
			enabled: false
		},
		{
			title: 'Metaattach',
			url: '/metattach',
			icon: 'assets/svgs/header/clip.svg',
			enabled: false
		},
		{
			title: 'Suite 16 Categories',
			url: '/suite16categories',
			icon: 'assets/svgs/header/suite.svg',
			enabled: false
		},
		{
			title: 'Short Lists',
			url: '/shortlists',
			icon: 'assets/svgs/header/shortlist.svg',
			enabled: false
		},
		{
			title: 'Partners',
			url: '/partners',
			icon: 'assets/svgs/header/users.svg',
			enabled: false
		},
		{
			title: 'Gamers',
			url: '/gamer-user-wallet-manager',
			icon: 'assets/svgs/regular/alicorn2.svg',
			enabled: false
		},
		{
			title: 'Transactions',
			url: '/gamer-user-wallet-transaction-manager',
			icon: 'assets/svgs/regular/alicorn2.svg',
			enabled: false
		},
		{
			title: 'Chat',
			url: '/chat',
			icon: 'assets/svgs/regular/comments-alt2.svg',
			enabled: false
		},
	];

	constructor(private platform: Platform,
		private router: Router,
		private storageService: Storage,
		private sharedService: SharedService) {

		this.openMenu(window.location.pathname, false);

		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				if (event.url !== undefined && event.url !== null) {
					if (event.url.indexOf('return-stripe-merchant') !== -1) {
						this.openMenu('/gamer-user-wallet-manager', true);
					} else if (event.url.indexOf('refresh-stripe-merchant') !== -1) {
						this.openMenu('/gamer-user-wallet-manager', true);
					}
				}

				if (event.url.indexOf('gamer') !== -1 && event.url.indexOf('chat') !== -1) {
					this.storageService.get('homeazzon_backoffice_isApprovedBackofficeUser').then((approvedBackofficeUser: boolean) => {
						if (!approvedBackofficeUser) {
							this.storageService.get('homeazzon_backoffice_Authenticated').then((isAuthenticated: boolean) => {
								if (isAuthenticated) {
									this.openMenu('/gamer-user-wallet-manager', true);
								} else {
									this.openMenu('/auth', true);
								}
							});
						};
					});
				}

				this.toggleSideNav();
			}

			if (event instanceof NavigationEnd) {
				this.openMenu(window.location.pathname, false);
			}
		});

	}

	ionViewDidEnter(): void {
		alert('adsfasdf');
	}

	ionViewWillEnter() {
		alert('ionViewWillEnter');
	}

	async ngOnInit(): Promise<void> {
		this.sharedService._isLoggedIn$.subscribe(async (res: boolean) => {
			this.isShowSideMenu = res;

			await this.toggleSideNav();
		});
	}

    private async toggleSideNav() {
        if (this.isShowSideMenu) {
            // Game Page Admin
            // Only show the 'Gamer Management' and 'Chat' menu items
            // if the user is an admin
            // DO NOT SHOW Other Buttons!
            await this.storageService.get('homeazzon_backoffice_IsGamePageAdmin').then(async (x: boolean) => {
                if (x !== undefined
                    && x !== null
                    && x === true) {
                    let a = this.menuItems;
                    let b = a.filter(x => x.title === 'Gamers' || x.title === 'Transactions' || x.title === 'Chat');

                    this.menuItems = b;

                    console.log('this.menuItems', this.menuItems);
                    //debugger;
                    // HomeaZZon homeazzon_backoffice_AuthorizedUsers
                    await this.handleApprovedBackofficeUser();
                } else {
                    // HomeaZZon Admin (Non GamePage Admin)
                    // Remove buttons for the 'Gamer Management' and 'Chat' menu items
                    // if there are no items in the GamePageUserAccess array
                    await this.storageService.get('homeazzon_backoffice_GamePageUserAccess').then(async (gamePageUser: any) => {
                        if (!gamePageUser
                            || gamePageUser === undefined
                            || gamePageUser === null
                            || gamePageUser.length === 0) {
                            let a = this.menuItems;
                            let b = a.filter(menuItem => menuItem.title !== 'Gamers' && menuItem.title !== 'Transactions' && menuItem.title !== 'Chat');

                            this.menuItems = b;
                        }
                        console.log('this.menuItems', this.menuItems);

                        // HomeaZZon homeazzon_backoffice_AuthorizedUsers
                        await this.handleApprovedBackofficeUser();
                    });
                }
            });
        }
    }

	private async handleApprovedBackofficeUser() {
		setTimeout(async () => {
			await this.storageService.get('homeazzon_backoffice_isApprovedBackofficeUser').then(async (approvedBackofficeUser: boolean) => {
				if (!approvedBackofficeUser) {
					let a = this.menuItems;
					let b = a.filter(menuItem => menuItem.title === 'Gamers' || menuItem.title === 'Transactions' || menuItem.title === 'Chat');

					console.log('b', b);
					//debugger;
					this.menuItems = b;
				}

				console.log('this.menuItems', this.menuItems);
			});
		}, 1000);
	}

	openMenu(selectedPath: string, isNavigate = true) {
		this.isShowSideMenu = selectedPath.includes('home') ? false : true;

		if (this.isShowSideMenu) {
			this.menuItems.forEach(menuItem => {
				menuItem.enabled = menuItem.url == selectedPath ? true : false;
			});

			if (isNavigate) {
				this.router.navigateByUrl(selectedPath);
			}
		}
	}

	toggleSideMenu() {
		this.menu.toggle();

		if (this.platform.width() >= 992) {
			this.isSidebarCollapsed = !this.isSidebarCollapsed;
			console.log("this.isSidebarCollapsed", this.isSidebarCollapsed);
		}
		this.isToggle.emit(this.isSidebarCollapsed);
	}
}
